import React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

function FallbackUI({ error, resetErrorBoundary }) {
  return (
    <div role="alert" style={{ padding: "48px", textAlign: "center" }}>
      <h2>Something went wrong.</h2>
      <p>We've been notified and are looking into it.</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        style={{ padding: "8px 16px" }}
      >
        Reload
      </button>
    </div>
  );
}

function ErrorBoundary({ children }) {
  return (
    <ReactErrorBoundary
      FallbackComponent={FallbackUI}
      onError={(error, info) => {
        // send to logger / Sentry
        console.error("Error caught:", error, info);
      }}
      onReset={() => {
        window.location.reload();
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;